<template>
    <div class="webmain">
      <div class="inabout">
        <div class="content">
          <div class="left">
            <div class="tit">关于中科智充</div>
            <div class="xian"></div>
            <div class="nr">安徽中科智充新能源科技有限公司国家级高新技术企业，双软企业，国家级科技型中小企业，中国科学院合肥技术创新工程院成员单位；中科智充作为一家专业的智慧能源系统解决方案供应商，一直致力新能源产业的研究与推广；在分布式多能互补、光储充系统、储能系统、智慧充换电、V2G于一体的综合智慧能源集成技术与优化解决方案方面有成熟的成功案例和实践经验。中科智充以综合性国家科学中心、国家科技创新型城市，长三角城市群副中心合肥为总部，目前在全国30多个省市均建立有分支机构运营服务中心，坚持以技术创新为核心，以中科院国家大科学工程为背景，建立“科学研究、技术开发、互联互通”三位一体的协同创新技术平台，坚持以服务终端客户为中心，以创新型的产品与服务为客户持续创造价值。
              中科智充核心专家由浙江大学电气学院博导，中科院合肥物质研究院硕博团队、高级工程师等高层次人才团队领衔。</div>
            <router-link v-if="isShow"  to="/about" class="more">了解更多</router-link>
          </div>
          <div class="right">
            <img height="576px" width="456px" src="@/assets/images/about/enterprise.png">
          </div>
          <div class="clean"></div>
        </div>
      </div>
    </div>
</template>

<script>
import Card from "./Card";
export default {
  name: "Enterprise",
  components:{
    Card
  },
  data() {
    return{
      isShow:true
    }
  },
  mounted() {
    let path = this.$route.path
    this.showMore(path)
  },
  methods:{
    showMore(path){
      if (path==='/about'){
        this.isShow = false
      }else {
        this.isShow = true
      }
    }
  }
}
</script>

<style scoped>
@import url(../../assets/css/style.css);
@import url(../../assets/css/reset.css);
@import url(../../assets/css/media.css);


</style>
